export function sendMousePosition(socket, payload) {
  socket.emit("send-mouse-position", payload);
}

export function mouseTracking(socket, payload) {
  socket.emit("mouse-tracking", payload);
}
